// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/line_desktop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/banner_shop_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Shop_nomad_container__loB0i {
  transition: all 0.2s linear;
  width: 100%;
  margin: 0 auto;
  margin-bottom: 70px;
  width: 85%;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__line__b0\\+WV {
  margin-top: 20px;
  border-radius: 8px;
  width: 100%;
  height: 52px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 0 10px;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__line__b0\\+WV .Shop_nomad_title__vChXC {
  font-weight: 400;
  font-size: 18px;
  line-height: 163%;
  color: #f6f6fc;
  padding-top: 10px;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__line_mob__JKm2W {
  display: none;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__title__4un8e {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  display: flex;
  justify-content: space-between;
  align-items: end;
  margin-top: 30px;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__title__4un8e .Shop_nomad_title__vChXC {
  font-size: 48px;
  font-weight: 700;
  font-style: normal;
  align-items: center;
  color: #f6f6fc;
  display: flex;
  justify-content: space-between;
  font-size: 40px;
}
.Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP {
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  width: 100%;
}
.Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS {
  margin-top: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  min-height: 119px;
  max-height: 60px;
  border-radius: 12px;
  display: flex;
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put {
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 5px;
  padding-left: 15px;
  padding-right: 15px;
}
.Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put .Shop_nomad_banner_p_one__EpFB- {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  font-size: 22px;
  color: #fff;
}
.Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put .Shop_nomad_banner_p_two__0mcGf {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  font-size: 15px;
  color: #e8f0ff;
  font-weight: 400;
}
.Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put .Shop_nomad_banner__group_img__aPn47 {
  display: none;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  flex-wrap: wrap;
  gap: 10px;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 30px;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej .Shop_nomad_reset_filter__SpEuu {
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
  color: #E0E0E0;
  display: flex;
  gap: 4px;
  align-items: center;
  white-space: nowrap;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej .Shop_nomad_chips__container__6ujgs {
  display: flex;
  gap: 12px;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej .Shop_nomad_chips__container_item__3Asij {
  background-color: rgba(255, 255, 255, 0.1);
  font-family: "Open Sans SemiBold";
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
  border-radius: 100px;
  padding: 6px 8px;
  color: #FFFFFF;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej .Shop_nomad_chips__container_item__3Asij img {
  display: none;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej .Shop_nomad_selected_chips__container_item__4KhTr {
  background-color: rgba(255, 255, 255, 0.3);
  color: #FFFFFF;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej .Shop_nomad_selected_chips__container_item__4KhTr img {
  display: block;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej .Shop_nomad_chips__container_divider__p2vOH {
  color: rgba(255, 255, 255, 0.15);
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_filter__kUDBi {
  font-family: "Open Sans SemiBold";
  font-size: 16px;
  align-items: center;
  background-color: #2e4b96;
  border-radius: 12px;
  color: #FFFFFF;
  cursor: pointer;
  display: flex;
  justify-content: center;
  gap: 4px;
  width: 138px;
  height: 42px;
  position: relative;
  transition: all 0.2s linear;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_filter__kUDBi .Shop_nomad_filterWrapper__jFCVu {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: #1E1E30;
  border-radius: 8px;
  color: #a8b3d1;
  left: 0;
  padding: 8px 0;
  position: absolute;
  top: 120%;
  width: 170px;
  z-index: 1;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_filter__kUDBi .Shop_nomad_filterWrapper__jFCVu .Shop_nomad_filterItem__v3kul {
  cursor: pointer;
  margin-bottom: 3px;
  padding: 6px 16px;
  transition: all 0.2s linear;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_filter__kUDBi .Shop_nomad_filterWrapper__jFCVu .Shop_nomad_filterItem__v3kul:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_filter__kUDBi .Shop_nomad_filterWrapper__jFCVu .Shop_nomad_selectedFilter__5vSZQ {
  background-color: rgba(255, 255, 255, 0.15);
  color: #FFFFFF;
}
.Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_filterModal__4s6zv {
  display: none;
}
.Shop_nomad_container__loB0i .Shop_nomad_mobFilter__S81GY {
  display: none;
}
.Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm {
  align-items: start;
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-top: 50px;
}
.Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_loaderContainer__mTLFA {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  color: #f6f6fc;
  display: flex;
  grid-column: span 4;
  justify-content: center;
  margin-top: 50px;
}
.Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_loaderContainer__mTLFA .Shop_nomad_loaderWrapper__pqS5L {
  background-color: #FFFFFF;
  border-radius: 133px;
  height: 8px;
  margin-top: 32px;
  width: 236px;
}
.Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_loaderContainer__mTLFA .Shop_nomad_loaderWrapper__pqS5L .Shop_nomad_loader__vTl71 {
  background-color: #eaae16;
  border-radius: 133px;
  height: 100%;
  animation: Shop_nomad_loader__vTl71 0.5s ease-in-out forwards;
  width: 0;
}
.Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_empty__YyJoC {
  font-size: 32px;
  font-weight: 700;
  font-style: normal;
  color: #f6f6fc;
  grid-column: span 4;
  margin-top: 50px;
  text-align: center;
}
.Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_empty__YyJoC .Shop_nomad_emptyInfo__xdtqF {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #a8b3d1;
  margin-top: 20px;
}
.Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_empty__YyJoC .Shop_nomad_emptyInfo__xdtqF a,
.Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_empty__YyJoC .Shop_nomad_emptyInfo__xdtqF .Shop_nomad_green__noDvg,
.Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_empty__YyJoC .Shop_nomad_emptyInfo__xdtqF .Shop_nomad_link__wl\\+pT {
  color: #ffd029;
}
.Shop_nomad_container__loB0i .Shop_nomad_more__5b8js {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  position: relative;
}
.Shop_nomad_container__loB0i .Shop_nomad_more__5b8js .Shop_nomad_down_button__8lOJp {
  background: #2e4b96;
  border-radius: 12px;
  width: 78px;
  height: 42px;
  font-size: 16px;
  color: #FFFFFF;
  font-family: "Open Sans SemiBold";
  cursor: pointer;
}
.Shop_nomad_container__loB0i .Shop_nomad_up__\\+umWN {
  align-items: center;
  background-color: #2e4b96;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  width: 42px;
  height: 42px;
  justify-content: center;
  position: absolute;
  right: 0;
  transition: all 0.2s linear;
}
.Shop_nomad_container__loB0i .Shop_nomad_modalOverlay__yh9y0 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(18, 20, 61, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

@keyframes Shop_nomad_loader__vTl71 {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}
@media (max-width: 1200px) {
  .Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 1100px) {
  .Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R {
    align-items: flex-start;
    flex-direction: column;
    margin-top: 32px;
    gap: 16px;
    display: none;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej {
    display: none;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_filterModal__4s6zv {
    background-color: #333217;
    color: #F2F740;
    display: flex;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R .Shop_nomad_filterModal__4s6zv:hover {
    background-color: #494711;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_mobFilter__S81GY {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_mobFilter__S81GY .Shop_nomad_mobFilter__games__ZDbNQ {
    display: flex;
    gap: 16px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_mobFilter__S81GY .Shop_nomad_mobFilter__games__ZDbNQ .Shop_nomad_mobFilter__game__C3kAZ {
    background-color: rgba(255, 255, 255, 0.1019607843);
    border-radius: 16px;
    color: #fff;
    padding: 6px 8px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_mobFilter__S81GY .Shop_nomad_mobFilter__games__ZDbNQ .Shop_nomad_mobFilter__game__C3kAZ.Shop_nomad_active__zpOOF {
    background-color: rgba(255, 255, 255, 0.3019607843);
  }
}
@media (max-width: 920px) {
  .Shop_nomad_container__filter__J937R .Shop_nomad_chips__CRgej {
    display: flex;
    flex-direction: column;
  }
  .Shop_nomad_container__filter__J937R .Shop_nomad_chips__container_divider__p2vOH {
    display: none;
  }
}
@media (max-width: 900px) {
  .Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put .Shop_nomad_banner_p_one__EpFB- {
    font-size: 18px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put .Shop_nomad_banner_p_two__0mcGf {
    font-size: 13px;
  }
}
@media (max-width: 850px) {
  .Shop_nomad_container__loB0i {
    padding-top: 75px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__img__GdIcQ {
    display: none;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS {
    background-image: none;
    max-height: none;
    border-radius: 8px;
    background: linear-gradient(90deg, #0051ff 0%, #0a74ff 100%);
    justify-content: center;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put {
    padding-top: 15px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put .Shop_nomad_banner_p_one__EpFB- {
    font-size: 20px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put .Shop_nomad_banner_p_two__0mcGf {
    font-size: 14px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_banner_wrapper__Y9WMP .Shop_nomad_banner__-tTLS .Shop_nomad_banner__group__G\\+put .Shop_nomad_banner__group_img__aPn47 {
    display: block;
    width: 100%;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_container__title__4un8e .Shop_nomad_title__vChXC {
    display: block;
    font-size: 36px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_container__filter__J937R {
    align-items: start;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm {
    grid-template-columns: 1fr;
    margin-top: 24px;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_empty__YyJoC {
    font-size: 24px;
    font-weight: 700;
    font-style: normal;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_wrapper__\\+QSCm .Shop_nomad_empty__YyJoC .Shop_nomad_emptyInfo__xdtqF {
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    margin-top: 20px;
  }
}
@media (max-width: 500px) {
  .Shop_nomad_container__loB0i .Shop_nomad_container__line__b0\\+WV {
    display: none;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_container__line_mob__JKm2W {
    margin-top: 20px;
    display: block;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    background: rgba(255, 112, 0, 0.25);
    display: flex;
    gap: 6px;
    padding: 10px 10px;
    align-items: center;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_container__line_mob__JKm2W .Shop_nomad_mob_line__Q6DH3 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_container__line_mob__JKm2W .Shop_nomad_mob_line__Q6DH3 .Shop_nomad_title__vChXC {
    font-weight: 600;
    font-size: 18px;
    line-height: 168%;
    color: #fff;
  }
  .Shop_nomad_container__loB0i .Shop_nomad_container__line_mob__JKm2W .Shop_nomad_mob_line__Q6DH3 .Shop_nomad_desc__SpaFJ {
    font-family: var(--second-family);
    font-weight: 400;
    font-size: 12px;
    line-height: 173%;
    color: #ffc785;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Shop/Shop.nomad.module.scss","webpack://./src/assets/styles/_colors.nomad.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,2BAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;AADF;AAEE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAAJ;AACI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCkDO;EDjDP,iBAAA;AACN;AAEE;EACE,aAAA;AAAJ;AAEE;EEWA,eAAA;EACA,gBAAA;EACA,kBAAA;EFXE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AAEJ;AADI;EE/BF,eAAA;EACA,gBAAA;EACA,kBAAA;EFgCI,mBAAA;EACA,cCiCO;EDhCP,aAAA;EACA,8BAAA;EACA,eAAA;AAIN;AADE;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAGJ;AAFI;EACE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAIN;AADM;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,QAAA;EAEA,kBAAA;EACA,mBAAA;AAER;AADQ;EEhEN,eAAA;EACA,gBAAA;EACA,kBAAA;EFgEQ,eAAA;EACA,WAAA;AAKV;AAHQ;EErEN,eAAA;EACA,gBAAA;EACA,kBAAA;EFqEQ,eAAA;EACA,cAAA;EACA,gBAAA;AAOV;AALQ;EACE,aAAA;AAOV;AADE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAGJ;AAFI;EEmDF,eAAA;EACA,gBAAA;EACA,kBAAA;EFnDI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAMN;AAJM;EACE,eAAA;EACA,mBAAA;EACA,eAAA;EACA,cCjHO;EDkHP,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;AAMR;AAHM;EACE,aAAA;EACA,SAAA;AAKR;AAHM;EACE,0CCrFG;EDsFH,iCAAA;EACA,qEAAA;EACA,oBAAA;EACA,gBAAA;EAEA,cCxDK;EDyDL,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAIR;AAFQ;EACE,aAAA;AAIV;AADM;EACE,0CCtGG;EDuGH,cCtEK;EDuEL,qEAAA;AAGR;AADQ;EACE,cAAA;AAGV;AAAM;EACE,gCChHG;ADkHX;AAEI;EACE,iCAAA;EACA,eAAA;EACA,mBAAA;EACA,yBCrGS;EDsGT,mBAAA;EACA,cCxFO;EDyFP,eAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;AAAN;AAEM;EEpBJ,eAAA;EACA,gBAAA;EACA,kBAAA;EFqBM,yBC/Hc;EDgId,kBAAA;EACA,cC3GI;ED4GJ,OAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AACR;AACQ;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,2BAAA;AACV;AACU;EACE,0CCzJD;AD0JX;AAGQ;EACE,2CC7JC;ED8JD,cC5HG;AD2Hb;AAUI;EACE,aAAA;AARN;AAYE;EACE,aAAA;AAVJ;AAaE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sCAAA;EACA,gBAAA;AAXJ;AAaI;EEnNF,eAAA;EACA,gBAAA;EACA,kBAAA;EFoNI,cC9JO;ED+JP,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAVN;AAYM;EACE,yBC/JK;EDgKL,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AAVR;AAYQ;EACE,yBC3LQ;ED4LR,oBAAA;EACA,YAAA;EACA,6DAAA;EACA,QAAA;AAVV;AAeI;EEnPF,eAAA;EACA,gBAAA;EACA,kBAAA;EFoPI,cCxLO;EDyLP,mBAAA;EACA,gBAAA;EACA,kBAAA;AAZN;AAcM;EE7NJ,eAAA;EACA,gBAAA;EACA,kBAAA;EF6NM,cC7LI;ED+LJ,gBAAA;AAXR;AAaQ;;;EAGE,cCnME;ADwLZ;AAiBE;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAfJ;AAgBI;EACE,mBC3NS;ED4NT,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cCjNO;EDkNP,iCAAA;EACA,eAAA;AAdN;AAkBE;EACE,mBAAA;EACA,yBCxOW;EDyOX,oBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AAhBJ;AAwBE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EAEA,WAAA;EACA,YAAA;EACA,uCCxQyB;EDyQzB,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAvBJ;;AA2BA;EACE;IACE,QAAA;EAxBF;EA2BA;IACE,WAAA;EAzBF;AACF;AA4BA;EAEI;IACE,kCAAA;EA3BJ;AACF;AA+BA;EAEI;IACE,uBAAA;IACA,sBAAA;IACA,gBAAA;IACA,SAAA;IACA,aAAA;EA9BJ;EAgCI;IACE,aAAA;EA9BN;EAiCI;IACE,yBC/VQ;IDgWR,cClWG;IDmWH,aAAA;EA/BN;EAiCM;IACE,yBAAA;EA/BR;EAoCE;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,gBAAA;EAlCJ;EAoCI;IACE,aAAA;IACA,SAAA;EAlCN;EAoCM;IACE,mDAAA;IACA,mBAAA;IACA,WAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,QAAA;EAlCR;EAoCQ;IACE,mDAAA;EAlCV;AACF;AAyCA;EAEI;IACE,aAAA;IACA,sBAAA;EAxCJ;EA0CE;IACE,aAAA;EAxCJ;AACF;AA4CA;EAKU;IACE,eAAA;EA9CV;EAgDQ;IACE,eAAA;EA9CV;AACF;AAqDA;EACE;IA2BE,iBAAA;EA7EF;EAoDI;IACE,aAAA;EAlDN;EAoDI;IACE,sBAAA;IACA,gBAAA;IACA,kBAAA;IACA,4DAAA;IACA,uBAAA;EAlDN;EAmDM;IACE,iBAAA;EAjDR;EAkDQ;IACE,eAAA;EAhDV;EAkDQ;IACE,eAAA;EAhDV;EAkDQ;IACE,cAAA;IACA,WAAA;EAhDV;EAwDI;IACE,cAAA;IACA,eAAA;EAtDN;EA0DE;IACE,kBAAA;EAxDJ;EA6DE;IACE,0BAAA;IACA,gBAAA;EA3DJ;EA6DI;IExcJ,eAAA;IACA,gBAAA;IACA,kBAAA;EF8YA;EA2DM;IE/TN,eAAA;IACA,gBAAA;IACA,kBAAA;IFgUQ,gBAAA;EAxDR;AACF;AA8DA;EAEI;IACE,aAAA;EA7DJ;EA+DE;IACE,gBAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mCAAA;IACA,aAAA;IACA,QAAA;IACA,kBAAA;IACA,mBAAA;EA7DJ;EA8DI;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;EA5DN;EA6DM;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,WAAA;EA3DR;EA6DM;IACE,iCAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,cAAA;EA3DR;AACF","sourcesContent":["@use 'assets/styles/global.nomad.scss' as *;\n\n.container {\n  transition: all 0.2s linear;\n  width: 100%;\n  margin: 0 auto;\n  margin-bottom: 70px;\n  width: 85%;\n  .container__line {\n    margin-top: 20px;\n    border-radius: 8px;\n    width: 100%;\n    height: 52px;\n    background-image: url(\"../../assets/images/line_desktop.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    padding: 0 10px;\n    .title {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 163%;\n      color: $text-title;\n      padding-top: 10px;\n    }\n  }\n  .container__line_mob {\n    display: none;\n  }\n  .container__title {\n    @include subtitle5;\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n    margin-top: 30px;\n    .title {\n      @include h2;\n\n      align-items: center;\n      color: $text-title;\n      display: flex;\n      justify-content: space-between;\n      font-size: 40px;\n    }\n  }\n  .banner_wrapper {\n    overflow-x: hidden;\n    overflow-y: hidden;\n    position: relative;\n    width: 100%;\n    overflow-x: hidden;\n    overflow-y: hidden;\n    position: relative;\n    width: 100%;\n    .banner {\n      margin-top: 20px;\n      background-image: url(\"../../assets/images/banner_shop_bg.png\");\n      background-repeat: no-repeat;\n      background-size: cover;\n      width: 100%;\n      min-height: 119px;\n      max-height: 60px;\n      border-radius: 12px;\n      display: flex;\n      background-position: right;\n      background-repeat: no-repeat;\n      background-size: cover;\n      justify-content: space-between;\n      align-items: center;\n      position: relative;\n      .banner__img {\n      }\n      .banner__group {\n        display: flex;\n        flex-direction: column;\n        justify-content: end;\n        gap: 5px;\n\n        padding-left: 15px;\n        padding-right: 15px;\n        .banner_p_one {\n          @include subtitle1b;\n          font-size: 22px;\n          color: #fff;\n        }\n        .banner_p_two {\n          @include subtitle1b;\n          font-size: 15px;\n          color: #e8f0ff;\n          font-weight: 400;\n        }\n        .banner__group_img {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .container__filter {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: end;\n    flex-wrap: wrap;\n    gap: 10px;\n    .chips {\n      @include body1;\n      display: flex;\n      gap: 12px;\n      align-items: center;\n      margin-top: 30px;\n\n      .reset_filter {\n        cursor: pointer;\n        white-space: nowrap;\n        font-size: 14px;\n        color: $c-light-grey;\n        display: flex;\n        gap: 4px;\n        align-items: center;\n        white-space: nowrap;\n      }\n\n      .chips__container {\n        display: flex;\n        gap: 12px;\n      }\n      .chips__container_item {\n        background-color: $light-10;\n        font-family: \"Open Sans SemiBold\";\n        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n        border-radius: 100px;\n        padding: 6px 8px;\n\n        color: $text-white;\n        cursor: pointer;\n        white-space: nowrap;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        font-size: 14px;\n\n        img {\n          display: none;\n        }\n      }\n      .selected_chips__container_item {\n        background-color: $light-30;\n        color: $text-white;\n        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;\n\n        img {\n          display: block;\n        }\n      }\n      .chips__container_divider {\n        color: $light-15;\n      }\n    }\n\n    .filter {\n      font-family: \"Open Sans SemiBold\";\n      font-size: 16px;\n      align-items: center;\n      background-color: $control-dark;\n      border-radius: 12px;\n      color: $text-white;\n      cursor: pointer;\n      display: flex;\n      justify-content: center;\n      gap: 4px;\n      width: 138px;\n      height: 42px;\n      position: relative;\n      transition: all 0.2s linear;\n\n      .filterWrapper {\n        @include body1;\n\n        background-color: $background-snackbar;\n        border-radius: 8px;\n        color: $text-body;\n        left: 0;\n        padding: 8px 0;\n        position: absolute;\n        top: 120%;\n        width: 170px;\n        z-index: 1;\n\n        .filterItem {\n          cursor: pointer;\n          margin-bottom: 3px;\n          padding: 6px 16px;\n          transition: all 0.2s linear;\n\n          &:hover {\n            background-color: $light-10;\n          }\n        }\n\n        .selectedFilter {\n          background-color: $light-15;\n          color: $text-white;\n        }\n      }\n\n      // &:hover {\n      //   background-color: #4a2c6f;\n      // }\n    }\n\n    .filterModal {\n      display: none;\n    }\n  }\n\n  .mobFilter {\n    display: none;\n  }\n\n  .wrapper {\n    align-items: start;\n    display: grid;\n    gap: 24px;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    margin-top: 50px;\n\n    .loaderContainer {\n      @include subtitle1b;\n\n      color: $text-title;\n      display: flex;\n      grid-column: span 4;\n      justify-content: center;\n      margin-top: 50px;\n\n      .loaderWrapper {\n        background-color: $text-white;\n        border-radius: 133px;\n        height: 8px;\n        margin-top: 32px;\n        width: 236px;\n\n        .loader {\n          background-color: $control-primary;\n          border-radius: 133px;\n          height: 100%;\n          animation: loader 0.5s ease-in-out forwards;\n          width: 0;\n        }\n      }\n    }\n\n    .empty {\n      @include h3;\n\n      color: $text-title;\n      grid-column: span 4;\n      margin-top: 50px;\n      text-align: center;\n\n      .emptyInfo {\n        @include subtitle5;\n        color: $text-body;\n\n        margin-top: 20px;\n\n        a,\n        .green,\n        .link {\n          color: $text-link;\n        }\n      }\n    }\n  }\n\n  .more {\n    display: flex;\n    justify-content: center;\n    margin-top: 40px;\n    position: relative;\n    .down_button {\n      background: $control-dark;\n      border-radius: 12px;\n      width: 78px;\n      height: 42px;\n      font-size: 16px;\n      color: $text-white;\n      font-family: \"Open Sans SemiBold\";\n      cursor: pointer;\n    }\n  }\n\n  .up {\n    align-items: center;\n    background-color: $control-dark;\n    border-radius: 100px; \n    cursor: pointer;\n    display: flex;\n    width: 42px;\n    height: 42px;\n    justify-content: center;\n    position: absolute;\n    right: 0;\n    transition: all 0.2s linear;\n    \n\n    // &:hover {\n    //   background-color: #4a2c6f;\n    // }\n  }\n\n  .modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n\n    width: 100%;\n    height: 100%;\n    background-color: $background-modal-secondary;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n  }\n}\n\n@keyframes loader {\n  0% {\n    width: 0;\n  }\n\n  100% {\n    width: 100%;\n  }\n}\n\n@media (max-width: 1200px) {\n  .container {\n    .wrapper {\n      grid-template-columns: 1fr 1fr 1fr;\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .container {\n    .container__filter {\n      align-items: flex-start;\n      flex-direction: column;\n      margin-top: 32px;\n      gap: 16px;\n      display: none;\n\n      .chips {\n        display: none;\n      }\n\n      .filterModal {\n        background-color: $c-dark-yellow;\n        color: $c-yellow;\n        display: flex;\n\n        &:hover {\n          background-color: #494711;\n        }\n      }\n    }\n\n    .mobFilter {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;     \n      margin-top: 20px;\n      \n      .mobFilter__games {\n        display: flex;\n        gap: 16px;\n\n        .mobFilter__game {\n          background-color: #FFFFFF1A;\n          border-radius: 16px;\n          color: #fff;\n          padding: 6px 8px;\n          display: flex;\n          align-items: center;\n          gap: 4px;\n\n          &.active {\n            background-color: #FFFFFF4D;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 920px) {\n  .container__filter {\n    .chips {\n      display: flex;\n      flex-direction: column;\n    }\n    .chips__container_divider {\n      display: none;\n    }\n  }\n}\n\n@media (max-width: 900px) {\n  .container {\n    .banner_wrapper {\n      .banner {\n        .banner__group {\n          .banner_p_one {\n            font-size: 18px;\n          }\n          .banner_p_two {\n            font-size: 13px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n    .banner_wrapper {\n      .banner__img {\n        display: none;\n      }\n      .banner {\n        background-image: none;\n        max-height: none;\n        border-radius: 8px;\n        background: linear-gradient(90deg, #0051ff 0%, #0a74ff 100%);\n        justify-content: center;\n        .banner__group {\n          padding-top: 15px;\n          .banner_p_one {\n            font-size: 20px;\n          }\n          .banner_p_two {\n            font-size: 14px;\n          }\n          .banner__group_img {\n            display: block;\n            width: 100%;\n          }\n        }\n      }\n    }\n\n    padding-top: 75px;\n    .container__title {\n      .title {\n        display: block;\n        font-size: 36px;\n      }\n    }\n\n    .container__filter {\n      align-items: start;\n      .filter {\n      }\n    }\n\n    .wrapper {\n      grid-template-columns: 1fr;\n      margin-top: 24px;\n\n      .empty {\n        @include subtitle1b;\n\n        .emptyInfo {\n          @include body1;\n\n          margin-top: 20px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .container {\n    .container__line {\n      display: none;\n    }\n    .container__line_mob {\n      margin-top: 20px;\n      display: block;\n      border-radius: 8px;\n      width: 100%;\n      height: 100%;\n      background: rgba(255, 112, 0, 0.25);\n      display: flex;\n      gap: 6px;\n      padding: 10px 10px;\n      align-items: center;\n      .mob_line {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        .title {\n          font-weight: 600;\n          font-size: 18px;\n          line-height: 168%;\n          color: #fff;\n        }\n        .desc {\n          font-family: var(--second-family);\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 173%;\n          color: #ffc785;\n        }\n      }\n    }\n  }\n}\n","$c-white: #ffffff;\n\n$c-black: #1B1E23;\n$c-light-black: #242424;\n\n$c-dark-grey: rgba(36, 36, 36, .3);\n$c-light-grey: #E0E0E0;\n$c-light-grey-lines: rgba(220, 220, 220, .1);\n\n$c-yellow: #F2F740;\n$c-light-yellow: #FFEB31;\n$c-dark-yellow: #333217;\n$c-dark-yellow-focus: #494711;\n\n$c-blue-main: #0CDCEA;\n$c-light-blue: #69F6FF;\n$c-dark-blue-btns: #193B41;\n$c-dark-blue-hover: #0A5360;\n\n$c-red: #F44336;\n$c-dark-red: #351C1D;\n\n$c-green: #07EF9C;\n$c-dark-green: #11362C;\n\n$c-blue: #1D92FF;\n$c-dark-blue: #19334F;\n\n$c-parimatch: #F1F813;\n$c-parimatch-light: rgb(241, 248, 19, .15);\n\n$c-dota: #BF2E1A;\n$c-dota-light: rgba(191, 46, 26, .15);\n\n// New colors\n\n$icon-main: #b6c0cf;\n$icon-secondary: #8997AC;\n$icon-chevron: #8195df;\n$icon-hover: #97ACFB;\n$icon-pressed: #6F80C1;\n$icon-white: #ffffff;\n$icon-notification: #D63854;\n$icon-warning: #E37B4C;\n$icon-deposit: #A4DF28;\n\n$light-10: rgba(255, 255, 255, .1);\n$light-15: rgba(255, 255, 255, .15);\n$light-30: rgba(255, 255, 255, .3);\n$light-45: rgba(255, 255, 255, .45);\n$light-50: rgba(255, 255, 255, .5);\n$light-60: rgba(255, 255, 255, .6);\n\n$background-main: #0e113a;\n$background-secondary: #12143D;\n$background-snackbar: #1E1E30;\n$background-input: #05051B;\n$background-modal-main: rgba(5, 5, 27, 0.7);\n$background-modal-secondary: rgba(18, 20, 61, 0.7);\n\n$control-primary: #eaae16;\n$control-hover: #ffd029;\n$control-pressed: #D39D14;\n$control-green: #78aa0f;\n$control-green-hover: #9EE509;\n$control-green-pressed: #60880C;\n$control-dark: #2e4b96;\n$control-dark-hover: #375ab4;\n$control-dark-pressed: #253C78;\n$control-light: #FFFFFF;\n$control-light-hover: #E5E5E5;\n$control-light-pressed: #D9D9D9;\n$control-light-toggle: #B7B7B7;\n$control-disabled: #2C2C4A;\n\n$text-title: #f6f6fc;\n$text-subtitle: #B5C0DF;\n$text-body: #a8b3d1;\n$text-link: #ffd029;\n$text-error: #ff6964;\n$text-warning: #ec985b;\n$text-white: #FFFFFF;\n$text-dark: #292621;\n\n$calendar-default: rgba(18, 20, 61, 0.8);\n$calendar-active: #12143D;\n$calendar-white: #ffffff;\n$calendar-dark-yellow: #333217;\n$calendar-text-yellow: #EAAE16;\n$calendar-dark-green: #2E4105;\n$calendar-text-green: #78AA0F;\n$calendar-dark-purple: #3A2159;\n$calendar-text-purple: #8F6ED4;\n$calendar-dark-blue: #19334F;\n$calendar-text-blue: #1D92FF;\n\n$dota-tag: rgba(255, 51, 51, 0.2);\n$dota-logo: #FF3333;\n$cs-tag: rgba(226, 182, 3, 0.15);\n$lol-tag: rgba(199, 155, 59, 0.15);\n$lol-logo: rgba(199, 155, 59, 1);\n","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Shop_nomad_container__loB0i`,
	"container__line": `Shop_nomad_container__line__b0+WV`,
	"title": `Shop_nomad_title__vChXC`,
	"container__line_mob": `Shop_nomad_container__line_mob__JKm2W`,
	"container__title": `Shop_nomad_container__title__4un8e`,
	"banner_wrapper": `Shop_nomad_banner_wrapper__Y9WMP`,
	"banner": `Shop_nomad_banner__-tTLS`,
	"banner__group": `Shop_nomad_banner__group__G+put`,
	"banner_p_one": `Shop_nomad_banner_p_one__EpFB-`,
	"banner_p_two": `Shop_nomad_banner_p_two__0mcGf`,
	"banner__group_img": `Shop_nomad_banner__group_img__aPn47`,
	"container__filter": `Shop_nomad_container__filter__J937R`,
	"chips": `Shop_nomad_chips__CRgej`,
	"reset_filter": `Shop_nomad_reset_filter__SpEuu`,
	"chips__container": `Shop_nomad_chips__container__6ujgs`,
	"chips__container_item": `Shop_nomad_chips__container_item__3Asij`,
	"selected_chips__container_item": `Shop_nomad_selected_chips__container_item__4KhTr`,
	"chips__container_divider": `Shop_nomad_chips__container_divider__p2vOH`,
	"filter": `Shop_nomad_filter__kUDBi`,
	"filterWrapper": `Shop_nomad_filterWrapper__jFCVu`,
	"filterItem": `Shop_nomad_filterItem__v3kul`,
	"selectedFilter": `Shop_nomad_selectedFilter__5vSZQ`,
	"filterModal": `Shop_nomad_filterModal__4s6zv`,
	"mobFilter": `Shop_nomad_mobFilter__S81GY`,
	"wrapper": `Shop_nomad_wrapper__+QSCm`,
	"loaderContainer": `Shop_nomad_loaderContainer__mTLFA`,
	"loaderWrapper": `Shop_nomad_loaderWrapper__pqS5L`,
	"loader": `Shop_nomad_loader__vTl71`,
	"empty": `Shop_nomad_empty__YyJoC`,
	"emptyInfo": `Shop_nomad_emptyInfo__xdtqF`,
	"green": `Shop_nomad_green__noDvg`,
	"link": `Shop_nomad_link__wl+pT`,
	"more": `Shop_nomad_more__5b8js`,
	"down_button": `Shop_nomad_down_button__8lOJp`,
	"up": `Shop_nomad_up__+umWN`,
	"modalOverlay": `Shop_nomad_modalOverlay__yh9y0`,
	"mobFilter__games": `Shop_nomad_mobFilter__games__ZDbNQ`,
	"mobFilter__game": `Shop_nomad_mobFilter__game__C3kAZ`,
	"active": `Shop_nomad_active__zpOOF`,
	"banner__img": `Shop_nomad_banner__img__GdIcQ`,
	"mob_line": `Shop_nomad_mob_line__Q6DH3`,
	"desc": `Shop_nomad_desc__SpaFJ`
};
export default ___CSS_LOADER_EXPORT___;
